import { ArrowUpBoldOutlineIcon } from './ArrowUpBoldOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 664AA4B5-DD9C-40AD-A69E-3CD314025AD3
 * name arrow-up-bold-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up-bold-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowTopBoldOutlineIcon = ArrowUpBoldOutlineIcon;
export default ArrowTopBoldOutlineIcon